export default {
  init() {
    // JavaScript to be fired on all pages

    // Uncomment this function for developement, to log items to console.
    // 
    // function log(elem) {
    //     return console.log(elem);
    // }

    let mobile_btn = document.getElementById('m-toggle');
    let mobile_nav = document.getElementById('offcanvas-nav');
    mobile_btn.addEventListener('click', function() {
        mobile_nav.classList.toggle('d-none');
        console.log('this is working');
        let mobile_atags = document.getElementById('mobile_nav').querySelectorAll('.nav-link');
        mobile_atags.forEach( (tag) => {
          tag.addEventListener('click', () => mobile_nav.classList.add('d-none'));
        });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js